import React, { createRef } from 'react';
import queryString from 'query-string';
import { apiGet } from '../../services/apiClient';
import {isSafeReturnUrl} from '../../services/trackingLink';

import { Map, Marker, Popup, TileLayer, FeatureGroup } from 'react-leaflet';
import Logos from "../parcels/form_v3/logos";
import { Button } from "semantic-ui-react";

export const carIcon = new L.Icon({
    iconUrl: '/img/leaflet-icon-car.png',
    iconRetinaUrl: '/img/leaflet-icon-car.png',
    iconAnchor: [5, 55],
    popupAnchor: [10, -44],
    iconSize: [30, 48]
});

export const destinationIcon = new L.Icon({
    iconUrl: '/img/leaflet-icon-destination.png',
    iconRetinaUrl: '/img/leaflet-icon-destination.png',
    iconAnchor: [5, 55],
    popupAnchor: [10, -44],
    iconSize: [30, 48]
});

export default class TrackingPage extends React.Component {
    constructor(args) {
        super(args);
        let queryValues = queryString.parse(this.props.location.search);
        let claimId = queryValues.claimid;

        this.intervalId = null;
        this.mapRef = createRef();
        this.groupRef = createRef();
        this.state = {
            busyCount: 0,
            claimId: claimId,
            parcelNumber: null,
            parcelCarColor: null,
            parcelCarModel: null,
            parcelCarNumber: null,
            parcelLegalName: null,
            parcelCourierName: null,
            parcelCourierPhoneNumber: null,
            parcelTransportType: null,
            yandexTrackingLink: null,
            status: null,
            isNeedTracking: false,
            isNotFound: false,

            carLat: null,
            carLon: null,
            destinationLat: null,
            destinationLon: null,
            mapCenter: [90, 90]
        };
    }

    componentDidMount() {
        let self = this;
        self.getParcelData(false);
    }

    updateBusyCount(inc) {
        this.setState((prevState, props) => {
            prevState.busyCount = prevState.busyCount + inc;
            return prevState;
        });
    }

    getParcelData(isForceUpdateDataWithIntegration) {
        this.updateBusyCount(1);
        let urlGetParcelData = 'tracking/getparceldata/' + this.state.claimId;
        if (isForceUpdateDataWithIntegration)
            urlGetParcelData += '?isForceUpdateDataWithIntegration=true';
        apiGet(urlGetParcelData)
            .then(data => {
                this.updateBusyCount(-1);
                let isNeedTracking = data.status.statusCode === 'CarrierRequestSent' ||
                    data.status.statusCode === 'CarrierRequestConfirmed' ||
                    data.status.statusCode === 'Shipped';
                this.setState({
                    parcelNumber: data.number,
                    status: data.status,
                    parcelCarColor: data.carColor,
                    parcelCarModel: data.carModel,
                    parcelCarNumber: data.carNumber,
                    parcelLegalName: data.legalName,
                    parcelCourierName: data.courierName,
                    parcelCourierPhoneNumber: data.courierPhoneNumber,
                    parcelTransportType: data.transportType,
                    yandexTrackingLink: data.yandexTrackingLink,
                    destinationLat: data.destinationLat,
                    destinationLon: data.destinationLon,
                    mapCenter: [data.destinationLat, data.destinationLon],
                    isNeedTracking: isNeedTracking
                });
                if (isNeedTracking) {
                    this.getParcelPosition(true);
                    this.intervalId = setInterval(() => { this.getParcelPosition(false) }, 10000);
                }
            })
            .catch(err => {
                this.updateBusyCount(-1);
                this.setState({ isNotFound: true });
                console.error(err);
            });
    }

    getParcelPosition(fitCenter) {
        apiGet('tracking/GetParcelPosition/' + this.state.claimId)
            .then(data => {
                if (data.isFinished) { //Если яндекс перестал отдавать координаты, значит посылка доставлена - нужно обновить статус посылки
                    clearInterval(this.intervalId);
                    this.getParcelData(true);
                    return;
                }
                let centerMapX = fitCenter ? this.calcCenterBetweenPoints(data.carLat, this.state.destinationLat) : this.state.mapCenter[0];
                let centerMapY = fitCenter ? this.calcCenterBetweenPoints(data.carLon, this.state.destinationLon) : this.state.mapCenter[1];
                this.setState({
                    carLat: data.carLat,
                    carLon: data.carLon,
                    timestamp: data.timestamp,

                    mapCenter: [centerMapX, centerMapY]
                }, () => {
                    if (fitCenter) {
                        if (this.mapRef != null && this.groupRef != null) {
                            let map = this.mapRef.leafletElement; //get native Map instance
                            let group = this.groupRef.leafletElement; //get native featureGroup instance
                            let bounds = group.getBounds();
                            if (bounds !== undefined)
                                map.fitBounds(bounds);
                        }
                    }
                });
            })
            .catch(err => {
                console.error(err);
            });
    }

    calcCenterBetweenPoints(aAxis, bAxis) {
        return (aAxis + bAxis) / 2;
    }

    // UI Section
    renderLogo() {
        return (
            <Logos className='pooling-express-logo_tracking' name='PoolingExpress'/>
        );
    }

    renderCarPosition() {
        if (this.state.carLat === null || this.state.carLon === null) {
            return null;
        }

        return (
            <Marker position={[this.state.carLat, this.state.carLon]} icon={carIcon}>
                <Popup>
                    Текущее положение курьера
                </Popup>
            </Marker>
        );
    }

    renderDestinationPoint() {
        if (this.state.destinationLat === null || this.state.destinationLon === null) {
            return null;
        }

        return (
            <Marker position={[this.state.destinationLat, this.state.destinationLon]} icon={destinationIcon}>
                <Popup>
                    Точка доставки
                </Popup>
            </Marker>
        );
    }

    renderBlockWithMap(isBusy) {
        if (isBusy || this.state.status === null) //пока грузим данные и статус неизвестен, ничего не показываем
            return null;
        if (this.state.isNeedTracking === false) {
            return null;
        }

        return (
            <div className="row">
                <div className="col-xs-12">
                    <div className="text-right text-bold">{this.state.timestamp}</div>
                    <div className="calc-box no-padding">
                        <Map ref={e => this.mapRef = e} center={this.state.mapCenter} zoom={13} style={{ "height": "400px" }}>
                            <TileLayer
                                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> for Pooling Express'
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            />
                            <FeatureGroup ref={e => this.groupRef = e}>
                                {this.renderCarPosition()}
                                {this.renderDestinationPoint()}
                            </FeatureGroup>
                        </Map>
                    </div>
                </div>
            </div>
        );
    }

    handleBackClick() {
        const queryValues = queryString.parse(this.props.location.search);
        const returnUrl = queryValues.returnUrl;
        if (isSafeReturnUrl(returnUrl)) {
            window.location.href = returnUrl;
            return;
        }

        if (this.props.history) {
            this.props.history.goBack();
        } else {
            window.history.back();
        }
    }

    renderParcelData(isBusy) {
        if (isBusy)
            return null;
        return (
            <div>
                <div className="row">
                    <div className="col-xs-12 calc-header">
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <div className="pull-left">
                                    {this.renderLogo()}
                                    <h3 style={{ marginBottom: 0, marginLeft: '16px' }}>Посылка: <span>{this.state.parcelNumber !== null
                                        ? this.state.parcelNumber
                                        : "номер не указан"}</span></h3>
                                </div>
                            </div>
                            <div className="buttons-block" style={{ marginLeft: 'auto', display: 'flex' }}>
                                <Button
                                    onClick={() => this.handleBackClick()}
                                >
                                    Назад
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-4 col-xs-12">
                        <div className="box calc-box" style={{ height: 195 }}>
                            <div className="calc-box-header">
                                <span>Курьер</span>
                            </div>
                            <div className="box-body">
                                <p><b>Юр лицо:</b> {this.state.parcelLegalName}</p>
                                <p style={{wordWrap: 'break-word', wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal'}}>
                                    <b>Курьер:</b> {this.state.parcelCourierName}
                                </p>
                                <p><b>Телефон:</b> {this.state.parcelCourierPhoneNumber}</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 col-xs-12">
                        <div className="box calc-box" style={{ height: 195 }}>
                            <div className="calc-box-header">
                                <span>Машина</span>
                            </div>
                            <div className="box-body">
                                <p style={{wordWrap: 'break-word', wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal'}}>
                                    <b>Тип транспорта:</b> {this.state.parcelTransportType}
                                </p>
                                <p style={{wordWrap: 'break-word', wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal'}}>
                                    <b>Модель машины:</b> {this.state.parcelCarModel}
                                </p>
                                <p style={{wordWrap: 'break-word', wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal'}}>
                                    <b>Номер машины:</b> {this.state.parcelCarNumber}
                                </p>
                                <p style={{wordWrap: 'break-word', wordBreak: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal'}}>
                                    <b>Цвет машины:</b> {this.state.parcelCarColor}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 col-xs-12">
                        <div className="box calc-box" style={{ height: 195 }}>
                            <div className="calc-box-header">
                                <span>Отслеживание</span>
                            </div>
                            <div className="box-body">
                                {this.state.yandexTrackingLink ? (
                                    <p>
                                        <a href={this.state.yandexTrackingLink} target="_blank" rel="noopener noreferrer" 
                                           style={{ wordBreak: 'break-all', color: '#007bff', textDecoration: 'underline' }}>
                                            Отследить посылку в Яндекс Go
                                        </a>
                                    </p>
                                ) : (
                                    <p>
                                        {this.state.status && this.state.status.statusCode === 'CourierFound' 
                                            ? "Как только курьер заберёт отправление - здесь появится ссылка на отслеживание."
                                            : "Как только курьер будет найден - здесь появится ссылка на отслеживание."}
                                    </p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderNotFound() {
        return (
            <div className="row">
                <div className="col-xs-12">
                    <div className="text-center" style={{ marginTop: 200 }}>
                        <span className="calc-h2">Указанная посылка не найдена</span>
                    </div>
                </div>
            </div>
        );
    }

    renderBusyOverlay(isBusy) {
        return isBusy
            ? <div className="loading">
                <img src="/img/spinner.gif" alt="loading" width="100" height="100" />
            </div>
            : null;
    }

    render() {
        let isBusy = this.state.busyCount > 0;

        if (this.state.isNotFound)
            return (
                <div>
                    <section className="container">
                        {this.renderNotFound()}
                    </section>
                </div>
            );

        return (
            <div>
                <section className="container">
                    {this.renderBusyOverlay(isBusy)}
                    {this.renderParcelData(isBusy)}
                    {this.renderBlockWithMap(isBusy)}
                </section>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./App/pages/tracking/trackingPage.jsx